import properties from "./properties";
import { AdTag } from "./types";
// import mockPayload from "../mocks/mock-multiple-nfl.json";
// import mockBrand from "../mocks/mock-brand";
// const mockPayload = false;

function queryStringBuilder(dict: Partial<{ [name: string]: string }>) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(dict)) {
    params.append(key, value as string);
  }

  return params.toString();
}

declare global {
  interface Window {
    adtagData?: AdTag;
    adtagId?: string;
  }
}

export async function getAdtag(id: string | null) {
  if (window.adtagData) {
    return window.adtagData;
  }

  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const response = await fetch(`https://${properties.adtagCdnUri}/${id}.json`, {
    method: "GET",
    mode: "cors", // no-cors, *cors, same-origin
    cache: "default",
    headers
  });

  return response.json();
}

export async function getJSON(url: string) {
  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const response = await fetch(url, {
    method: "GET",
    mode: "cors", // no-cors, *cors, same-origin
    cache: "default",
    headers
  });

  return response.json();
}

export async function getBet(
  id: string | null,
  ref?: string,
  clickUrl?: string,
  lang?: string,
  useMock?: string | boolean
) {
  id = window.adtagId || id;
  if (useMock) {
    // return import("../mocks/mock-multiple-nfl.json");
  }

  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const queryParams =
    typeof ref === "string" ||
    typeof clickUrl === "string" ||
    typeof lang === "string"
      ? queryStringBuilder({
          ref,
          clickUrl,
          lang
        })
      : undefined;

  let requestUrl = `https://${properties.dataApiUri}/${id}/adtag.js`;

  if (queryParams) {
    requestUrl += `?${queryParams}&v=4`;
  }

  const response = await fetch(requestUrl, {
    method: "GET",
    mode: "cors", // no-cors, *cors, same-origin
    cache: "default",
    headers
  });

  return response.json();
}
